import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { UnknownError } from '@cian/peperrors';

import { EDemandTrapScreen } from '../../containers/DemandActionContainer';
import {
  EStatus,
  fetchCreateHomeownerMessageFromOffer,
  ICreateHomeownerMessageFromOfferResponse200 as IRes200,
  ICreateHomeownerMessageFromOfferResponse400 as IRes400,
} from '../../repositories/demand/v2/create-homeowner-message-from-offer';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { getResponseError } from '../../utils/logging/getResponseError';

interface ISendDemandProps {
  offerId?: number;
  confirmationCode?: string;
  setScreen(screen: EDemandTrapScreen): void;
}

const DEFAULT_ERROR_MESSAGE = 'Ошибка при создании заявки по объявлению от собственника';

export async function sendDemand({ offerId, confirmationCode, setScreen }: ISendDemandProps) {
  const httpApi = getHttpApi();
  const logger = getLogger();

  const smsCode = typeof confirmationCode === 'string' ? confirmationCode : undefined;

  const parameters = {
    offerId,
    confirmationCode: smsCode ?? undefined,
    source: 'chats',
  };

  try {
    const res = await fetchCreateHomeownerMessageFromOffer<IRes200, IRes400>({
      httpApi,
      parameters,
    });

    if (res.statusCode === 200) {
      switch (res.response.status) {
        case EStatus.NeedPhoneConfirm:
          setScreen(EDemandTrapScreen.NeedCode);

          return;
        case EStatus.CodeError:
          setScreen(EDemandTrapScreen.SmsCodeError);

          return;
        default:
          setScreen(EDemandTrapScreen.Sent);

          return;
      }
    }

    throw getResponseError({
      domain: EExceptionDomain.Demand,
      response: res.response,
      defaultMessage: DEFAULT_ERROR_MESSAGE,
    });
  } catch (error) {
    setScreen(EDemandTrapScreen.GlobalError);

    const exception = new UnknownError({
      domain: EExceptionDomain.Demand,
      message: DEFAULT_ERROR_MESSAGE,
      details: error,
    });

    logger.error(exception, {
      microserviceName: 'demand',
      pathApi: '/v2/create-homeowner-message-from-offer/',
      parameters: JSON.stringify(parameters),
    });
  }
}
